import React from "react";

import "./Title.css";

export default function Title() {
  return (
    <div className="Title">
      <h1 className="app-title">World Weather</h1>
    </div>
  );
}
